/** Mirrors isCerRole / isCerAdminRole in @regigov/domain: the test admin (TESTING_MODE) ranks above cer_admin. */
const CER_ROLES: readonly string[] = ['test_admin', 'cer_admin', 'cer_officer'];
const CER_ADMIN_ROLES: readonly string[] = ['test_admin', 'cer_admin'];

export const isCerRole = (roles: readonly string[] | undefined): boolean => roles?.some((r) => CER_ROLES.includes(r)) ?? false;
export const isCerAdminRole = (roles: readonly string[] | undefined): boolean => roles?.some((r) => CER_ADMIN_ROLES.includes(r)) ?? false;
